import { usePunditUserContext } from "@circle-react/contexts";

export const useIsWorkflowsEnabled = () => {
  const { currentCommunity, isLoading } = usePunditUserContext();

  return Boolean(!isLoading && currentCommunity?.workflows_enabled);
};
